module.exports = __webpack_public_path__ + "img/step5.096fa5e1.png";